export const translations = {
  pt: {
    nav: {
      about: "Sobre",
      committees: "Comissões",
      program: "Programa",
      submissions: "Submissões",
      registration: "Inscrição",
      sponsors: "Apoios",
    },
    hero: {
      date: "17-18 Abril 2026",
      title1: "10º Congresso Internacional de",
      title2: "Atividade Física",
      title3: "e",
      title4: "Desporto",
      countdown: "O evento começa em:",
      registerBtn: "Inscrever-se Agora",
      programBtn: "Ver Programa",
      days: "Dias",
      hours: "Horas",
      min: "Min",
      sec: "Seg",
      para1: 'Sob o tema <strong>"30 anos a formar em Ciências do Desporto"</strong>, esta edição comemorativa pretende assinalar três décadas de formação, investigação e intervenção na área das Ciências do Desporto, constituindo-se como um momento de celebração, reflexão crítica e projeção do futuro da área.',
      para2: "O 10.º CIAFD será um espaço privilegiado de discussão científica, divulgação e partilha de conhecimento, promovendo a troca de experiências entre docentes, investigadores, profissionais, estudantes e demais interessados nas áreas da Atividade Física, Exercício, Desporto e Saúde. O programa científico integrará comunicações orais e em formato póster, bem como, conferências convidadas por especialistas de reconhecido mérito nacional e internacional, garantindo a qualidade científica e a pertinência das temáticas abordadas.",
      para3: "Pretende-se que este congresso seja um momento agregador da comunidade académica e profissional, reforçando redes de colaboração, valorizando o percurso formativo desenvolvido ao longo de 30 anos e contribuindo ativamente para o desenvolvimento das Ciências do Desporto em Portugal e no contexto internacional.",
      para4: "Acreditamos que a sua participação será fundamental para o sucesso deste evento e contamos consigo para celebrar connosco esta data marcante.",
    },
    about: {
      subtitle: "Sobre o Congresso",
      title: "Dois Dias de Excelência Académica e Celebração",
      description: "O Congresso Internacional de Atividade Física e Desporto reúne especialistas, investigadores, professores e estudantes para partilhar conhecimento e celebrar a evolução das ciências do desporto.",
      communications: "Comunicações",
      participants: "Participantes",
      speakers: "Oradores",
      days: "Dias",
    },
    committees: {
      subtitle: "Organização",
      title: "Comissões do Congresso",
      organizing: "Comissão Organizadora",
      scientific: "Comissão Científica",
      members: "membros",
      comingSoon: "Brevemente",
      comingSoonText: "Brevemente disponível",
    },
    program: {
      subtitle: "Agenda",
      title: "Programa do Evento",
      day1Tab: "17 ABRIL",
      day2Tab: "18 ABRIL",
      workshopInfo: "Ver Detalhes do Workshop",
      speakersInfo: "Ver Oradores e Informação",
      bookInfo: "Sobre o Livro e o Editor",
      confirmedPresences: "Presenças Confirmadas",
      bookLaunch: "Lançamento de Livro",
      editor: "Editor",
      previewBook: "Preview do Livro",
      biography: "Biografia",
      trainer: "Formador(a)",
      workshopContent: "Conteúdo do Workshop",
    },
    submissions: {
      subtitle: "Participe",
      title: "Submissão de Resumos",
      areas: "Áreas de Submissão",
      areasDesc: "O programa estruturar-se-á em torno de quatro eixos principais:",
      thematicArea1: "Atividade Física e Saúde",
      thematicArea2: "Treino e Performance Desportiva",
      thematicArea3: "Educação Física e Sociedade",
      thematicArea4: "Desporto de Natureza e Sustentabilidade",
      documentsTitle: "Documentos e Templates",
      dates: "Datas Importantes",
      submissionDeadline: "Submissão de Resumos",
      deadlineDate1: "até 20 de Março 2026",
      notificationDate: "Notificação de Resposta",
      deadlineDate2: "até 27 de Março 2026",
      authorRegistration: "Inscrição do Autor",
      deadlineDate3: "até 31 de Março 2026",
      normasTitle: "Normas de Submissão",
      templateOral: "Template Comunicação Oral",
      templatePoster: "Template e-Poster",
      downloadPdf: "Download PDF",
      downloadPptx: "Download PPTX",
      submitBtnAction: "Submeter Resumo",
      closedBtn: "Submissões Encerradas",
      formDialogTitle: "Submeter Resumo",
      formDialogDesc: "Preencha todos os campos obrigatórios (*) para submeter o seu resumo.",
      section1: "1. Tipo de Submissão",
      presentationType: "Tipo de Apresentação *",
      oral: "Comunicação Oral",
      poster: "Póster",
      thematicAreaLabel: "Eixo Temático *",
      selectArea: "Selecione o eixo temático",
      section2: "2. Título do Trabalho",
      titlePt: "Título (Português) *",
      titlePtPlaceholder: "Título em português",
      titleEn: "Title (English) *",
      titleEnPlaceholder: "Title in English",
      section3: "3. Afiliações",
      addAffiliation: "Adicionar Afiliação",
      affiliationInstructions: "Adicione todas as afiliações dos autores de acordo com as normas",
      affiliationFormat: "Entidade, Localidade (País)",
      affiliationExample: "Instituto Politécnico de Beja, Beja (Portugal)",
      affiliationNote: "Na secção seguinte, deverá selecionar as afiliações correspondentes a cada autor.",
      affiliationPlaceholder: "Entidade, Localidade (País)",
      section4Title: "4. Autores",
      addAuthor: "Adicionar Autor",
      authorSelectNote: "Para cada autor, selecione as afiliações correspondentes.",
      authorLabel: "Autor",
      authorPlaceholder: "Nome completo do autor",
      section5: "5. Resumo (máx. 3000 caracteres)",
      abstractPt: "Resumo (Português/Espanhol) *",
      abstractPtPlaceholder: "Escreva o resumo em português ou espanhol...",
      abstractEn: "Abstract (Inglês) *",
      abstractEnPlaceholder: "Write the abstract in English...",
      section6: "6. Palavras-chave (máx. 5)",
      keywordsPtLabel: "Português *",
      keywordsEnLabel: "English *",
      keywordPlaceholder: "Palavra-chave",
      keywordPlaceholderEn: "Keyword",
      section7: "7. Referências Bibliográficas",
      referencesPlaceholder: "Liste as referências bibliográficas...",
      section8: "8. Autor Responsável pela Correspondência",
      section9: "9. Autor que irá Apresentar",
      nameLabel: "Nome *",
      emailLabel: "Email *",
      namePlaceholder: "Nome completo",
      emailPlaceholder: "email@exemplo.com",
      submitting: "A submeter...",
      submitBtn: "Submeter Resumo",
      submitSuccess: "Resumo submetido com sucesso!",
      submitSuccessDesc: "Receberá notificação sobre a avaliação.",
      submitError: "Erro na submissão",
      tryAgain: "Por favor, tente novamente.",
      validationSelectType: "Selecione o tipo de apresentação",
      validationSelectArea: "Selecione o eixo temático",
      validationAddAffiliation: "Adicione pelo menos uma afiliação",
      validationAddAuthor: "Adicione pelo menos um autor",
      validationAddKeywords: "Adicione palavras-chave em português e inglês",
      validationKeywordsPaired: "Cada palavra-chave deve ter versão em português e inglês",
      validationAuthorAffiliation: "Todos os autores devem ter pelo menos uma afiliação associada",
      affiliationWarning: "Todos os autores devem ter pelo menos uma afiliação selecionada",
      validationAbstractPtMax: "O resumo em português deve ter no máximo 3000 caracteres",
      validationAbstractEnMax: "O resumo em inglês deve ter no máximo 3000 caracteres",
      emailNotice: "Após submeter, verifique o seu email (incluindo a pasta de spam/lixo) para notificações sobre a avaliação.",
    },
    celebration: {
      date: "18 de Abril 2026",
      title1: "Almoço de Celebração dos",
      title2: "30 Anos",
      title3: "de Formação em Ciências do Desporto",
      description1: "Junte-se a nós para um momento especial de confraternização! Reunimos todos os que fizeram parte desta história de 30 anos – ex-alunos, docentes, investigadores, profissionais e amigos que contribuíram para o crescimento das Ciências do Desporto no IPBeja.",
      description2: "Uma oportunidade única para reencontrar colegas, partilhar memórias e celebrar três décadas de formação, investigação e paixão pelo desporto e atividade física.",
      saturday: "Sábado",
      specialEvent: "Evento Especial",
      yearsHistory: "30 Anos de História",
      lunchPrice: "Valor do Almoço",
      reserveBtn: "Reservar Lugar",
      lunchNote: "* O almoço é opcional e pode ser adicionado à inscrição do congresso",
    },
    pricing: {
      title: "Valores de Inscrição",
      description: "",
      includesTitle: "A inscrição no congresso inclui:",
      feature1: "Acesso a todas as sessões científicas",
      feature2: "Workshops e comunicações orais",
      feature3: "Conferência plenária e mesa redonda",
      feature4: "Sessão de e-pósteres",
      feature5: "Coffee breaks e networking",
      period1: "1º Prazo de Inscrições",
      period1Deadline: "Até 22 de Março 2026",
      period2: "2º Prazo de Inscrições",
      period2Deadline: "23 de Março a 12 de Abril 2026",
      recommended: "Preço Recomendado",
      cat1: "Estudantes e Diplomados IPBeja",
      cat2: "Estudantes de outras instituições de Ensino Superior | Orientadores institucionais IPBeja | Investigadores SPRINT | Docentes da REDESPP",
      cat3: "Profissionais e público em geral",
      registerBtn: "Inscrever-me",
      lunchTitle: "Almoço de Celebração – 30 Anos",
      lunchSubtitle: "18 de Abril 2026 • Valor adicional à inscrição",
      priceLabel: "Valor",
      learnMore: "+ Info",
    },
    lunchModal: {
      title: "Almoço de Celebração – 30 Anos",
      location: "Restaurante Seara",
      locationDetail: "Beja Parque Hotel. Rua Francisco Miguel Duarte, 1, Beja, 7800-510 Portugal",
      welcome: "Receção de Boas-Vindas (Welcome Drink)",
      lunchTitle: "Almoço",
      couvert: "Couvert e Entradas",
      couvertDesc: "Seleção de pão regional, manteiga, azeitonas, queijo fresco, paio e diversas saladas.",
      soup: "Sopa",
      soupDesc: "Creme de coentros.",
      fish: "Prato de Peixe",
      fishDesc: "Bacalhau gratinado com espinafres em crosta de pão alentejano.",
      meat: "Prato de Carne",
      meatDesc: "Perna de porco assada acompanhada de batatinhas à padeiro.",
      desserts: "Sobremesas",
      dessertsDesc: "Buffet de sobremesas variadas e fruta laminada.",
      drinks: "Bebidas incluídas durante o almoço",
      drinksDesc: "Água, sumos, cerveja, vinhos branco e tinto e café.",
      liveMusic: "Música ao vivo durante o almoço",
      note: "Nota",
      noteDesc: "As bebidas incluídas no serviço estarão disponíveis apenas durante o período do almoço. Após este momento, qualquer consumo adicional poderá ser efetuado no bar do espaço e será pago diretamente pelos participantes.",
    },
    accreditation: {
      ipdjText: "IPDJ — Creditação para revalidação do Título Profissional de Técnico de Exercício Físico, Treinador de Desporto e Diretor Técnico (2,4 UC)",
      teacherText: "Reconhecimento de Ação de Curta Duração (6h) — Formação Contínua de Professores (Despacho nº 5741/2015, de 29 de maio)",
    },
    masters: {
      badge: "Ano Letivo 2026/2027",
      title: "Mestrado em Atividade Física e Saúde",
      subtitle: "Prepare o próximo ano académico",
      studyPlan: "Plano de Estudos",
      studyPlanTitle: "Plano de Estudos",
      sem1: "1.º Ano | 1.º Semestre",
      sem2: "1.º Ano | 2.º Semestre",
      year2: "2.º Ano | Anual",
      option: "Opção",
      thesesTitle: "Dissertações de Mestrado",
      thesesSubtitle: "Investigação produzida pelos nossos mestrandos",
      thesesCount: "dissertações",
      author: "Autor",
      year: "Ano",
      allYears: "Todos",
      testimonials: {
        t1: "As unidades curriculares estão muito bem organizadas e alinhadas com os desafios e contextos atuais da área da promoção da saúde e do exercício.",
        t2: "O mestrado ajudou-me a desenvolver competências para pesquisar de forma autónoma sobre temas relevantes e interpretar evidência científica de forma crítica.",
        t3: "Senti uma enorme disponibilidade e apoio dos professores, que acompanham os estudantes de forma muito próxima no desenvolvimento dos trabalhos académicos.",
        t4: "O mestrado proporciona oportunidades de contacto com experiências internacionais, através de programas como Erasmus e programas intensivos.",
        t5: "A estrutura do mestrado é bastante flexível, o que facilita conciliar os estudos com a atividade profissional, sendo muito adequado para trabalhadores-estudantes.",
        t6: "O mestrado ajudou-me a compreender melhor as condicionantes práticas que existem quando avaliamos diferentes tipos de populações.",
        t7: "Aprofundei conhecimentos em áreas com as quais tinha menos contacto e adquirir competências mais técnicas para intervenções específicas ao nível do treino individualizado.",
      },
    },
    registration: {
      subtitle: "Inscrição",
      title: "Garanta a Sua Participação",
      description: "Selecione a sua categoria e anexe o comprovativo de pagamento.",
      period1Title: "1º Prazo de Inscrições",
      period1Desc: "Até 22 de Março 2026 - Preços mais baixos!",
      period2Title: "2º Prazo de Inscrições",
      period2Desc: "23 de Março a 12 de Abril 2026",
      closedTitle: "Inscrições Encerradas",
      closedDesc: "O prazo de inscrições terminou a 12 de Abril 2026",
      paymentDataTitle: "Dados para Pagamento",
      bank: "Banco",
      country: "País",
      holder: "Titular",
      address: "Morada",
      formTitle: "Formulário de Inscrição",
      fullName: "Nome Completo *",
      email: "Email *",
      institution: "Instituição *",
      role: "Função *",
      selectRole: "Selecione a sua função",
      roleStudentIpbeja: "Estudante IPBeja",
      roleDiplomaIpbeja: "Diplomados IPBeja",
      roleProfessor: "Professor/Docente",
      roleResearcher: "Investigador",
      roleProfExercise: "Profissional na área do Exercício Físico",
      roleOther: "Outro",
      participationType: "Tipo de Participação *",
      selectParticipation: "Selecione o tipo",
      participantOnly: "Participante",
      presenterComm: "Apresenta comunicação (oral e/ou poster)",
      tefLicense: "Nº Cédula de Técnico de Exercício Físico",
      optional: "Opcional",
      workshopSelection: "Seleção de Workshops (opcional)",
      workshopNote: "Apenas pode selecionar um workshop por horário.",
      timeSlot1: "Horário 14:30 - 16:00",
      timeSlot2: "Horário 16:30 - 18:00",
      noWorkshopSlot: "Nenhum workshop neste horário",
      waitingList: "Lista de Espera",
      waitingListNotice: "O WSP 6 já atingiu o número máximo de vagas. Ao selecionar este workshop, ficará em lista de espera e será contactado(a) caso surja uma vaga.",
      registrationsClosed: "Inscrições Encerradas",
      limitedSpots: "Vagas Limitadas",
      billing: "Dados para Faturação",
      invoiceName: "Nome para Fatura *",
      invoiceNamePlaceholder: "Nome ou entidade a constar na fatura",
      invoiceAddress: "Morada *",
      invoiceAddressPlaceholder: "Morada completa para faturação",
      invoicePostalCode: "Código Postal e Localidade *",
      invoicePostalCodePlaceholder: "Ex: 7800-295 Beja",
      invoiceCountry: "País *",
      invoiceCountryPlaceholder: "Ex: Portugal",
      nif: "NIF (Número de Identificação Fiscal) *",
      nifPlaceholder: "Número de contribuinte",
      lunchTitle: "Almoço de Celebração – 30 Anos",
      lunchSubtitle: "18 de Abril 2026 • Evento especial de confraternização",
      paymentProof: "Comprovativo de Pagamento *",
      uploadFile: "Clique para carregar",
      fileTypes: "PDF, JPG ou PNG (máx. 10MB)",
      lunchAddon: "+ Almoço 30 Anos",
      totalPrice: "Total a Pagar",
      closed: "Inscrições Encerradas",
      processing: "A processar...",
      confirmBtn: "Confirmar Inscrição",
      success: "Inscrição realizada com sucesso!",
      successDesc: "Receberá confirmação após validação do pagamento.",
      error: "Erro na inscrição",
      fileTooLarge: "Ficheiro muito grande",
      fileTooLargeDesc: "O ficheiro deve ter no máximo 10MB",
      lunchOnly: "Apenas Almoço dos 30 Anos",
      lunchOnlyDesc: "Inscrição exclusiva para o almoço de celebração",
      selectCategory: "Selecione uma categoria de inscrição",
      categoryLabel: "Categoria de Inscrição *",
      selectCategoryPlaceholder: "Escolha a sua categoria",
      emailNotice: "Após submeter, verifique o seu email (incluindo a pasta de spam/lixo) para a confirmação.",
      formStepNotice: "Preencha o formulário abaixo e clique em Confirmar para completar a inscrição.",
      xpsTitle: "Informação XPS Network",
      xpsHasAccount: "Já usa ou já usou o XPS Network?",
      xpsYes: "Sim",
      xpsNo: "Não",
      xpsEmail: "Email já associado à conta XPS",
      xpsEmailPlaceholder: "Indique o email da sua conta XPS",
      xpsEmailNew: "Email a associar à nova conta XPS",
      xpsEmailNewPlaceholder: "Indique o email para criar a conta XPS",
    },
    sponsors: {
      subtitle: "Parceiros",
      title: "Organização, Parcerias e Apoios",
      scrollHint: "Deslize para ver mais",
      supportedBy: "Com o apoio de",
      withSupportOf: "Com o apoio de",
    },
    footer: {
      description: "10º Congresso Internacional de Atividade Física e Desporto.",
      contacts: "Contactos",
      links: "Links",
      about: "Sobre",
      program: "Programa",
      submissions: "Submissões",
      prices: "Valores",
      registration: "Inscrição",
      admin: "Administração",
      copyright: "© 2026 CIAFD. Todos os direitos reservados.",
    },
    upload: {
      title: "Submissão de Apresentação",
      submissionId: "ID da Submissão *",
      name: "Nome *",
      email: "Email *",
      presentationType: "Tipo de Apresentação *",
      selectType: "Selecione o tipo",
      oralComm: "Comunicação Oral",
      poster: "e-Poster",
      file: "Ficheiro da Apresentação *",
      uploadBtn: "Clique para carregar ficheiro",
      fileTypes: "Apenas ficheiros .ppt ou .pptx",
      submitBtn: "Submeter Apresentação",
      submitting: "A enviar...",
      success: "Apresentação submetida com sucesso!",
      error: "Erro ao submeter",
      backToSite: "Voltar ao site",
      fileSelected: "Ficheiro selecionado",
    },
    admin: {
      title: "Administração",
      password: "Password",
      enterPassword: "Password",
      login: "Entrar",
      loggingIn: "A entrar...",
      backToSite: "Voltar ao site",
      wrongPassword: "Password incorreta",
      loginSuccess: "Login bem-sucedido!",
      registrations: "Inscrições",
      abstracts: "Resumos",
      presentations: "Apresentações",
      stats: "Estatísticas",
      confirmed: "Confirmadas",
      revenue: "Receita",
      accepted: "Aceites",
      logout: "Sair",
      refresh: "Atualizar",
      export: "Exportar Excel",
      name: "Nome",
      email: "Email",
      type: "Tipo",
      modality: "Modalidade",
      price: "Preço",
      proof: "Comprovativo",
      status: "Estado",
      actions: "Ações",
      view: "Ver",
      pending: "Pendente",
      confirmedStatus: "Confirmado",
      responsible: "Responsável",
      reviewer: "Revisor",
      assign: "Atribuir",
      none: "Nenhum",
      revision: "Revisão",
      rejected: "Rejeitado",
      noRegistrations: "Nenhuma inscrição",
      noSubmissions: "Nenhuma submissão",
      noPresentations: "Nenhuma apresentação",
      delete: "Eliminar",
      download: "Descarregar",
      resendEmail: "Reenviar email",
      statusUpdated: "Estado atualizado",
      assignmentUpdated: "Atribuição atualizada",
      emailSentToReviewer: "Email enviado ao revisor",
      deleted: "Eliminado",
      errorUpdating: "Erro ao atualizar",
      errorDeleting: "Erro ao eliminar",
      errorLoading: "Erro ao carregar dados",
      downloadWord: "Descarregar Word",
      workshopStats: "Inscrições por Workshop",
      enrolled: "inscritos",
      totalRegistrations: "Total de Inscrições",
      totalSubmissions: "Total de Submissões",
      totalRevenue: "Receita Total",
      institution: "Instituição",
      date: "Data",
      category: "Categoria",
      submissionId: "ID Submissão",
      thematicArea: "Eixo Temático",
      titleLabel: "Título",
      submitter: "Autor",
      fileName: "Ficheiro",
      size: "Tamanho",
    },
  },
  en: {
    nav: {
      about: "About",
      committees: "Committees",
      program: "Program",
      submissions: "Submissions",
      registration: "Registration",
      sponsors: "Sponsors",
    },
    hero: {
      date: "17-18 April 2026",
      title1: "10th International Congress of",
      title2: "Physical Activity",
      title3: "and",
      title4: "Sport",
      countdown: "The event starts in:",
      registerBtn: "Register Now",
      programBtn: "View Program",
      days: "Days",
      hours: "Hours",
      min: "Min",
      sec: "Sec",
      para1: 'Under the theme <strong>"30 years of training in Sport Sciences"</strong>, this commemorative edition aims to mark three decades of training, research and intervention in the field of Sport Sciences, serving as a moment of celebration, critical reflection and projection of the future of the area.',
      para2: "The 10th CIAFD will be a privileged space for scientific discussion, dissemination and knowledge sharing, promoting the exchange of experiences among teachers, researchers, professionals, students and others interested in the areas of Physical Activity, Exercise, Sport and Health. The scientific program will include oral and poster communications, as well as invited conferences by specialists of recognized national and international merit, ensuring the scientific quality and relevance of the topics addressed.",
      para3: "The aim is for this congress to be an aggregating moment for the academic and professional community, strengthening collaboration networks, valuing the training path developed over 30 years and actively contributing to the development of Sport Sciences in Portugal and internationally.",
      para4: "We believe that your participation will be fundamental to the success of this event and we count on you to celebrate this landmark date with us.",
    },
    about: {
      subtitle: "About the Congress",
      title: "Two Days of Academic Excellence and Celebration",
      description: "The International Congress of Physical Activity and Sport brings together experts, researchers, professors and students to share knowledge and celebrate the evolution of sport sciences.",
      communications: "Communications",
      participants: "Participants",
      speakers: "Speakers",
      days: "Days",
    },
    committees: {
      subtitle: "Organization",
      title: "Congress Committees",
      organizing: "Organizing Committee",
      scientific: "Scientific Committee",
      members: "members",
      comingSoon: "Coming Soon",
      comingSoonText: "Coming soon",
    },
    program: {
      subtitle: "Schedule",
      title: "Event Program",
      day1Tab: "17 APRIL",
      day2Tab: "18 APRIL",
      workshopInfo: "View Workshop Details",
      speakersInfo: "View Speakers and Information",
      bookInfo: "About the Book and Editor",
      confirmedPresences: "Confirmed Presences",
      bookLaunch: "Book Launch",
      editor: "Editor",
      previewBook: "Book Preview",
      biography: "Biography",
      trainer: "Trainer",
      workshopContent: "Workshop Content",
    },
    submissions: {
      subtitle: "Participate",
      title: "Abstract Submission",
      areas: "Submission Areas",
      areasDesc: "The program will be structured around four main axes:",
      thematicArea1: "Physical Activity and Health",
      thematicArea2: "Training and Sports Performance",
      thematicArea3: "Physical Education and Society",
      thematicArea4: "Nature Sports and Sustainability",
      documentsTitle: "Documents and Templates",
      dates: "Important Dates",
      submissionDeadline: "Abstract Submission",
      deadlineDate1: "until March 20, 2026",
      notificationDate: "Notification of Response",
      deadlineDate2: "until March 27, 2026",
      authorRegistration: "Author Registration",
      deadlineDate3: "until March 31, 2026",
      normasTitle: "Submission Guidelines",
      templateOral: "Oral Communication Template",
      templatePoster: "e-Poster Template",
      downloadPdf: "Download PDF",
      downloadPptx: "Download PPTX",
      submitBtnAction: "Submit Abstract",
      closedBtn: "Submissions Closed",
      formDialogTitle: "Submit Abstract",
      formDialogDesc: "Fill in all required fields (*) to submit your abstract.",
      section1: "1. Submission Type",
      presentationType: "Presentation Type *",
      oral: "Oral Communication",
      poster: "Poster",
      thematicAreaLabel: "Thematic Area *",
      selectArea: "Select thematic area",
      section2: "2. Work Title",
      titlePt: "Title (Portuguese) *",
      titlePtPlaceholder: "Title in Portuguese",
      titleEn: "Title (English) *",
      titleEnPlaceholder: "Title in English",
      section3: "3. Affiliations",
      addAffiliation: "Add Affiliation",
      affiliationInstructions: "Add all author affiliations according to the guidelines",
      affiliationFormat: "Entity, Location (Country)",
      affiliationExample: "Polytechnic Institute of Beja, Beja (Portugal)",
      affiliationNote: "In the next section, you should select the corresponding affiliations for each author.",
      affiliationPlaceholder: "Entity, Location (Country)",
      section4Title: "4. Authors",
      addAuthor: "Add Author",
      authorSelectNote: "For each author, select the corresponding affiliations.",
      authorLabel: "Author",
      authorPlaceholder: "Author's full name",
      section5: "5. Abstract (max. 3000 characters)",
      abstractPt: "Abstract (Portuguese) *",
      abstractPtPlaceholder: "Write the abstract in Portuguese...",
      abstractEn: "Abstract (Inglês) *",
      abstractEnPlaceholder: "Write the abstract in English...",
      section6: "6. Keywords (max. 5)",
      keywordsPtLabel: "Portuguese *",
      keywordsEnLabel: "English *",
      keywordPlaceholder: "Keyword",
      keywordPlaceholderEn: "Keyword",
      section7: "7. References",
      referencesPlaceholder: "List the bibliographic references...",
      section8: "8. Corresponding Author",
      section9: "9. Presenting Author",
      nameLabel: "Name *",
      emailLabel: "Email *",
      namePlaceholder: "Full name",
      emailPlaceholder: "email@example.com",
      submitting: "Submitting...",
      submitBtn: "Submit Abstract",
      submitSuccess: "Abstract submitted successfully!",
      submitSuccessDesc: "You will receive notification about the evaluation.",
      submitError: "Submission error",
      tryAgain: "Please try again.",
      validationSelectType: "Select the presentation type",
      validationSelectArea: "Select the thematic area",
      validationAddAffiliation: "Add at least one affiliation",
      validationAddAuthor: "Add at least one author",
      validationAddKeywords: "Add keywords in Portuguese and English",
      validationKeywordsPaired: "Each keyword must have both Portuguese and English versions",
      validationAuthorAffiliation: "All authors must have at least one associated affiliation",
      affiliationWarning: "All authors must have at least one affiliation selected",
      validationAbstractPtMax: "The Portuguese abstract must have at most 3000 characters",
      validationAbstractEnMax: "The English abstract must have at most 3000 characters",
      emailNotice: "After submitting, please check your email (including spam/junk folder) for evaluation notifications.",
    },
    celebration: {
      date: "April 18, 2026",
      title1: "Celebration Lunch for",
      title2: "30 Years",
      title3: "of Training in Sport Sciences",
      description1: "Join us for a special moment of fellowship! We bring together all those who have been part of this 30-year story – alumni, professors, researchers, professionals and friends who contributed to the growth of Sport Sciences at IPBeja.",
      description2: "A unique opportunity to reconnect with colleagues, share memories and celebrate three decades of training, research and passion for sport and physical activity.",
      saturday: "Saturday",
      specialEvent: "Special Event",
      yearsHistory: "30 Years of History",
      lunchPrice: "Lunch Price",
      reserveBtn: "Reserve Your Seat",
      lunchNote: "* The lunch is optional and can be added to the congress registration",
    },
    pricing: {
      title: "Registration Fees",
      description: "",
      includesTitle: "Congress registration includes:",
      feature1: "Access to all scientific sessions",
      feature2: "Workshops and oral communications",
      feature3: "Plenary conference and round table",
      feature4: "e-Poster session",
      feature5: "Coffee breaks and networking",
      period1: "1st Registration Period",
      period1Deadline: "Until March 22, 2026",
      period2: "2nd Registration Period",
      period2Deadline: "March 23 to April 12, 2026",
      recommended: "Recommended Price",
      cat1: "IPBeja Students and Graduates",
      cat2: "Students from other Higher Education institutions | IPBeja Institutional Supervisors | SPRINT Researchers | REDESPP Professors",
      cat3: "Professionals and general public",
      registerBtn: "Register",
      lunchTitle: "Celebration Lunch – 30 Years",
      lunchSubtitle: "April 18, 2026 • Additional to registration fee",
      priceLabel: "Price",
      learnMore: "+ Info",
    },
    lunchModal: {
      title: "Celebration Lunch – 30 Years",
      location: "Restaurante Seara",
      locationDetail: "Beja Parque Hotel. Rua Francisco Miguel Duarte, 1, Beja, 7800-510 Portugal",
      welcome: "Welcome Reception (Welcome Drink)",
      lunchTitle: "Lunch",
      couvert: "Bread Basket & Starters",
      couvertDesc: "Selection of regional bread, butter, olives, fresh cheese, cured sausage and assorted salads.",
      soup: "Soup",
      soupDesc: "Coriander cream soup.",
      fish: "Fish Course",
      fishDesc: "Gratinated codfish with spinach in Alentejo bread crust.",
      meat: "Meat Course",
      meatDesc: "Roast pork leg with baker-style potatoes.",
      desserts: "Desserts",
      dessertsDesc: "Assorted dessert buffet and sliced fruit.",
      drinks: "Drinks included during lunch",
      drinksDesc: "Water, juices, beer, white and red wine, and coffee.",
      liveMusic: "Live music during lunch",
      note: "Note",
      noteDesc: "Drinks included in the service will only be available during the lunch period. After this time, any additional consumption may be made at the venue bar and will be paid directly by participants.",
    },
    accreditation: {
      ipdjText: "IPDJ — Accreditation for revalidation of the Professional Title of Physical Exercise Technician, Sports Coach and Technical Director (2.4 CU)",
      teacherText: "Recognition of Short Duration Action (6h) — Continuing Teacher Training (Dispatch No. 5741/2015, May 29)",
    },
    masters: {
      badge: "Academic Year 2026/2027",
      title: "Master's in Physical Activity and Health",
      subtitle: "Prepare your next academic year",
      studyPlan: "Study Plan",
      studyPlanTitle: "Study Plan",
      sem1: "1st Year | 1st Semester",
      sem2: "1st Year | 2nd Semester",
      year2: "2nd Year | Annual",
      option: "Option",
      thesesTitle: "Master's Theses",
      thesesSubtitle: "Research produced by our master's students",
      thesesCount: "theses",
      author: "Author",
      year: "Year",
      allYears: "All",
      testimonials: {
        t1: "The courses are very well organized and aligned with the current challenges and contexts in the area of health promotion and exercise.",
        t2: "The master's helped me develop skills to research independently on relevant topics and interpret scientific evidence critically.",
        t3: "I felt enormous availability and support from the professors, who closely accompany students in the development of their academic work.",
        t4: "The master's provides opportunities for contact with international experiences, through programs such as Erasmus and intensive programs.",
        t5: "The structure of the master's is quite flexible, which makes it easier to balance studies with professional activity, being very suitable for working students.",
        t6: "The master's helped me better understand the practical constraints that exist when assessing different types of populations.",
        t7: "I deepened knowledge in areas I had less contact with and acquired more technical skills for specific interventions in individualized training.",
      },
    },
    registration: {
      subtitle: "Registration",
      title: "Secure Your Participation",
      description: "Select your category and attach proof of payment.",
      period1Title: "1st Registration Period",
      period1Desc: "Until March 22, 2026 - Lowest prices!",
      period2Title: "2nd Registration Period",
      period2Desc: "March 23 to April 12, 2026",
      closedTitle: "Registrations Closed",
      closedDesc: "The registration deadline ended on April 12, 2026",
      paymentDataTitle: "Payment Details",
      bank: "Bank",
      country: "Country",
      holder: "Account Holder",
      address: "Address",
      formTitle: "Registration Form",
      fullName: "Full Name *",
      email: "Email *",
      institution: "Institution *",
      role: "Role *",
      selectRole: "Select your role",
      roleStudentIpbeja: "IPBeja Student",
      roleDiplomaIpbeja: "IPBeja Graduate",
      roleProfessor: "Professor/Teacher",
      roleResearcher: "Researcher",
      roleProfExercise: "Exercise Professional",
      roleOther: "Other",
      participationType: "Participation Type *",
      selectParticipation: "Select type",
      participantOnly: "Attendee",
      presenterComm: "Presenting communication (oral and/or poster)",
      tefLicense: "Exercise Professional License No.",
      optional: "Optional",
      workshopSelection: "Workshop Selection (optional)",
      workshopNote: "You can only select one workshop per time slot.",
      timeSlot1: "Time Slot 14:30 - 16:00",
      timeSlot2: "Time Slot 16:30 - 18:00",
      noWorkshopSlot: "No workshop in this slot",
      waitingList: "Waiting List",
      waitingListNotice: "WSP 6 has reached its maximum capacity. By selecting this workshop, you will be placed on a waiting list and contacted if a spot becomes available.",
      registrationsClosed: "Registrations Closed",
      limitedSpots: "Limited Spots",
      billing: "Billing Information",
      invoiceName: "Invoice Name *",
      invoiceNamePlaceholder: "Name or entity for the invoice",
      invoiceAddress: "Address *",
      invoiceAddressPlaceholder: "Full billing address",
      invoicePostalCode: "Postal Code and City *",
      invoicePostalCodePlaceholder: "E.g.: 7800-295 Beja",
      invoiceCountry: "Country *",
      invoiceCountryPlaceholder: "E.g.: Portugal",
      nif: "Tax Identification Number *",
      nifPlaceholder: "Tax number",
      lunchTitle: "Celebration Lunch – 30 Years",
      lunchSubtitle: "April 18, 2026 • Special fellowship event",
      paymentProof: "Proof of Payment *",
      uploadFile: "Click to upload",
      fileTypes: "PDF, JPG or PNG (max. 10MB)",
      lunchAddon: "+ 30 Years Lunch",
      totalPrice: "Total to Pay",
      closed: "Registrations Closed",
      processing: "Processing...",
      confirmBtn: "Confirm Registration",
      success: "Registration successful!",
      successDesc: "You will receive confirmation after payment validation.",
      error: "Registration error",
      fileTooLarge: "File too large",
      fileTooLargeDesc: "File must be at most 10MB",
      lunchOnly: "30 Years Lunch Only",
      lunchOnlyDesc: "Registration exclusively for the celebration lunch",
      selectCategory: "Select a registration category",
      categoryLabel: "Registration Category *",
      selectCategoryPlaceholder: "Choose your category",
      emailNotice: "After submitting, please check your email (including spam/junk folder) for confirmation.",
      formStepNotice: "Fill in the form below and click Confirm to complete your registration.",
      xpsTitle: "XPS Network Information",
      xpsHasAccount: "Do you already use or have you used XPS Network?",
      xpsYes: "Yes",
      xpsNo: "No",
      xpsEmail: "Email already associated with your XPS account",
      xpsEmailPlaceholder: "Enter your XPS account email",
      xpsEmailNew: "Email to associate with new XPS account",
      xpsEmailNewPlaceholder: "Enter the email to create the XPS account",
    },
    sponsors: {
      subtitle: "Partners",
      title: "Organization, Partnerships and Support",
      scrollHint: "Scroll to see more",
      supportedBy: "Supported by",
      withSupportOf: "Supported by",
    },
    footer: {
      description: "10th International Congress of Physical Activity and Sport.",
      contacts: "Contacts",
      links: "Links",
      about: "About",
      program: "Program",
      submissions: "Submissions",
      prices: "Fees",
      registration: "Registration",
      admin: "Administration",
      copyright: "© 2026 CIAFD. All rights reserved.",
    },
    upload: {
      title: "Presentation Submission",
      submissionId: "Submission ID *",
      name: "Name *",
      email: "Email *",
      presentationType: "Presentation Type *",
      selectType: "Select type",
      oralComm: "Oral Communication",
      poster: "e-Poster",
      file: "Presentation File *",
      uploadBtn: "Click to upload file",
      fileTypes: "Only .ppt or .pptx files",
      submitBtn: "Submit Presentation",
      submitting: "Uploading...",
      success: "Presentation submitted successfully!",
      error: "Error submitting",
      backToSite: "Back to site",
      fileSelected: "File selected",
    },
    admin: {
      title: "Administration",
      password: "Password",
      enterPassword: "Password",
      login: "Login",
      loggingIn: "Logging in...",
      backToSite: "Back to site",
      wrongPassword: "Wrong password",
      loginSuccess: "Login successful!",
      registrations: "Registrations",
      abstracts: "Abstracts",
      presentations: "Presentations",
      stats: "Statistics",
      confirmed: "Confirmed",
      revenue: "Revenue",
      accepted: "Accepted",
      logout: "Logout",
      refresh: "Refresh",
      export: "Export Excel",
      name: "Name",
      email: "Email",
      type: "Type",
      modality: "Modality",
      price: "Price",
      proof: "Proof",
      status: "Status",
      actions: "Actions",
      view: "View",
      pending: "Pending",
      confirmedStatus: "Confirmed",
      responsible: "Responsible",
      reviewer: "Reviewer",
      assign: "Assign",
      none: "None",
      revision: "Revision",
      rejected: "Rejected",
      noRegistrations: "No registrations",
      noSubmissions: "No submissions",
      noPresentations: "No presentations",
      delete: "Delete",
      download: "Download",
      resendEmail: "Resend email",
      statusUpdated: "Status updated",
      assignmentUpdated: "Assignment updated",
      emailSentToReviewer: "Email sent to reviewer",
      deleted: "Deleted",
      errorUpdating: "Error updating",
      errorDeleting: "Error deleting",
      errorLoading: "Error loading data",
      downloadWord: "Download Word",
      workshopStats: "Registrations per Workshop",
      enrolled: "enrolled",
      totalRegistrations: "Total Registrations",
      totalSubmissions: "Total Submissions",
      totalRevenue: "Total Revenue",
      institution: "Institution",
      date: "Date",
      category: "Category",
      submissionId: "Submission ID",
      thematicArea: "Thematic Area",
      titleLabel: "Title",
      submitter: "Author",
      fileName: "File",
      size: "Size",
    },
  },
  es: {
    nav: {
      about: "Acerca",
      committees: "Comités",
      program: "Programa",
      submissions: "Envíos",
      registration: "Inscripción",
      sponsors: "Patrocinadores",
    },
    hero: {
      date: "17-18 Abril 2026",
      title1: "10º Congreso Internacional de",
      title2: "Actividad Física",
      title3: "y",
      title4: "Deporte",
      countdown: "El evento comienza en:",
      registerBtn: "Inscribirse Ahora",
      programBtn: "Ver Programa",
      days: "Días",
      hours: "Horas",
      min: "Min",
      sec: "Seg",
      para1: 'Bajo el tema <strong>"30 años formando en Ciencias del Deporte"</strong>, esta edición conmemorativa pretende señalar tres décadas de formación, investigación e intervención en el área de las Ciencias del Deporte, constituyéndose como un momento de celebración, reflexión crítica y proyección del futuro del área.',
      para2: "El 10.º CIAFD será un espacio privilegiado de discusión científica, divulgación y compartición de conocimiento, promoviendo el intercambio de experiencias entre docentes, investigadores, profesionales, estudiantes y demás interesados en las áreas de Actividad Física, Ejercicio, Deporte y Salud. El programa científico integrará comunicaciones orales y en formato póster, así como conferencias invitadas por especialistas de reconocido mérito nacional e internacional, garantizando la calidad científica y la pertinencia de las temáticas abordadas.",
      para3: "Se pretende que este congreso sea un momento agregador de la comunidad académica y profesional, reforzando redes de colaboración, valorizando el recorrido formativo desarrollado a lo largo de 30 años y contribuyendo activamente al desarrollo de las Ciencias del Deporte en Portugal y en el contexto internacional.",
      para4: "Creemos que su participación será fundamental para el éxito de este evento y contamos con usted para celebrar con nosotros esta fecha destacada.",
    },
    about: {
      subtitle: "Sobre el Congreso",
      title: "Dos Días de Excelencia Académica y Celebración",
      description: "El Congreso Internacional de Actividad Física y Deporte reúne a expertos, investigadores, profesores y estudiantes para compartir conocimientos y celebrar la evolución de las ciencias del deporte.",
      communications: "Comunicaciones",
      participants: "Participantes",
      speakers: "Ponentes",
      days: "Días",
    },
    committees: {
      subtitle: "Organización",
      title: "Comités del Congreso",
      organizing: "Comité Organizador",
      scientific: "Comité Científico",
      members: "miembros",
      comingSoon: "Próximamente",
      comingSoonText: "Próximamente disponible",
    },
    program: {
      subtitle: "Agenda",
      title: "Programa del Evento",
      day1Tab: "17 ABRIL",
      day2Tab: "18 ABRIL",
      workshopInfo: "Ver Detalles del Taller",
      speakersInfo: "Ver Ponentes e Información",
      bookInfo: "Sobre el Libro y el Editor",
      confirmedPresences: "Presencias Confirmadas",
      bookLaunch: "Lanzamiento de Libro",
      editor: "Editor",
      previewBook: "Vista Previa del Libro",
      biography: "Biografía",
      trainer: "Formador(a)",
      workshopContent: "Contenido del Taller",
    },
    submissions: {
      subtitle: "Participe",
      title: "Envío de Resúmenes",
      areas: "Áreas de Envío",
      areasDesc: "El programa se estructurará en torno a cuatro ejes principales:",
      thematicArea1: "Actividad Física y Salud",
      thematicArea2: "Entrenamiento y Rendimiento Deportivo",
      thematicArea3: "Educación Física y Sociedad",
      thematicArea4: "Deporte de Naturaleza y Sostenibilidad",
      documentsTitle: "Documentos y Plantillas",
      dates: "Fechas Importantes",
      submissionDeadline: "Envío de Resúmenes",
      deadlineDate1: "hasta el 20 de Marzo 2026",
      notificationDate: "Notificación de Respuesta",
      deadlineDate2: "hasta el 27 de Marzo 2026",
      authorRegistration: "Inscripción del Autor",
      deadlineDate3: "hasta el 31 de Marzo 2026",
      normasTitle: "Normas de Envío",
      templateOral: "Plantilla Comunicación Oral",
      templatePoster: "Plantilla e-Póster",
      downloadPdf: "Descargar PDF",
      downloadPptx: "Descargar PPTX",
      submitBtnAction: "Enviar Resumen",
      closedBtn: "Envíos Cerrados",
      formDialogTitle: "Enviar Resumen",
      formDialogDesc: "Complete todos los campos obligatorios (*) para enviar su resumen.",
      section1: "1. Tipo de Envío",
      presentationType: "Tipo de Presentación *",
      oral: "Comunicación Oral",
      poster: "Póster",
      thematicAreaLabel: "Eje Temático *",
      selectArea: "Seleccione eje temático",
      section2: "2. Título del Trabajo",
      titlePt: "Título (Portugués) *",
      titlePtPlaceholder: "Título en portugués",
      titleEn: "Título (Inglés) *",
      titleEnPlaceholder: "Title in English",
      section3: "3. Afiliaciones",
      addAffiliation: "Añadir Afiliación",
      affiliationInstructions: "Añada todas las afiliaciones de los autores según las normas",
      affiliationFormat: "Entidad, Localidad (País)",
      affiliationExample: "Instituto Politécnico de Beja, Beja (Portugal)",
      affiliationNote: "En la siguiente sección, deberá seleccionar las afiliaciones correspondientes a cada autor.",
      affiliationPlaceholder: "Entidad, Localidad (País)",
      section4Title: "4. Autores",
      addAuthor: "Añadir Autor",
      authorSelectNote: "Para cada autor, seleccione las afiliaciones correspondientes.",
      authorLabel: "Autor",
      authorPlaceholder: "Nombre completo del autor",
      section5: "5. Resumen (máx. 3000 caracteres)",
      abstractPt: "Resumen (Portugués) *",
      abstractPtPlaceholder: "Escriba el resumen en portugués...",
      abstractEn: "Abstract (Inglês) *",
      abstractEnPlaceholder: "Write the abstract in English...",
      section6: "6. Palabras clave (máx. 5)",
      keywordsPtLabel: "Portugués *",
      keywordsEnLabel: "English *",
      keywordPlaceholder: "Palabra clave",
      keywordPlaceholderEn: "Keyword",
      section7: "7. Referencias Bibliográficas",
      referencesPlaceholder: "Liste las referencias bibliográficas...",
      section8: "8. Autor Responsable de la Correspondencia",
      section9: "9. Autor que Presentará",
      nameLabel: "Nombre *",
      emailLabel: "Email *",
      namePlaceholder: "Nombre completo",
      emailPlaceholder: "email@ejemplo.com",
      submitting: "Enviando...",
      submitBtn: "Enviar Resumen",
      submitSuccess: "¡Resumen enviado con éxito!",
      submitSuccessDesc: "Recibirá notificación sobre la evaluación.",
      submitError: "Error en el envío",
      tryAgain: "Por favor, inténtelo de nuevo.",
      validationSelectType: "Seleccione el tipo de presentación",
      validationSelectArea: "Seleccione el eje temático",
      validationAddAffiliation: "Añada al menos una afiliación",
      validationAddAuthor: "Añada al menos un autor",
      validationAddKeywords: "Añada palabras clave en portugués e inglés",
      validationKeywordsPaired: "Cada palabra clave debe tener versión en portugués e inglés",
      validationAuthorAffiliation: "Todos los autores deben tener al menos una afiliación asociada",
      affiliationWarning: "Todos los autores deben tener al menos una afiliación seleccionada",
      validationAbstractPtMax: "El resumen en portugués debe tener como máximo 3000 caracteres",
      validationAbstractEnMax: "El resumen en inglés debe tener como máximo 3000 caracteres",
      emailNotice: "Tras enviar, revise su email (incluida la carpeta de spam/correo no deseado) para notificaciones sobre la evaluación.",
    },
    celebration: {
      date: "18 de Abril 2026",
      title1: "Almuerzo de Celebración de los",
      title2: "30 Años",
      title3: "de Formación en Ciencias del Deporte",
      description1: "¡Únase a nosotros para un momento especial de confraternización! Reunimos a todos los que han sido parte de esta historia de 30 años – exalumnos, docentes, investigadores, profesionales y amigos que contribuyeron al crecimiento de las Ciencias del Deporte en IPBeja.",
      description2: "Una oportunidad única para reencontrarse con colegas, compartir recuerdos y celebrar tres décadas de formación, investigación y pasión por el deporte y la actividad física.",
      saturday: "Sábado",
      specialEvent: "Evento Especial",
      yearsHistory: "30 Años de Historia",
      lunchPrice: "Precio del Almuerzo",
      reserveBtn: "Reservar Lugar",
      lunchNote: "* El almuerzo es opcional y puede añadirse a la inscripción del congreso",
    },
    pricing: {
      title: "Valores de Inscripción",
      description: "",
      includesTitle: "La inscripción al congreso incluye:",
      feature1: "Acceso a todas las sesiones científicas",
      feature2: "Talleres y comunicaciones orales",
      feature3: "Conferencia plenaria y mesa redonda",
      feature4: "Sesión de e-pósteres",
      feature5: "Coffee breaks y networking",
      period1: "1er Plazo de Inscripciones",
      period1Deadline: "Hasta el 22 de Marzo 2026",
      period2: "2º Plazo de Inscripciones",
      period2Deadline: "23 de Marzo a 12 de Abril 2026",
      recommended: "Precio Recomendado",
      cat1: "Estudiantes y Diplomados IPBeja",
      cat2: "Estudiantes de otras instituciones de Educación Superior | Orientadores institucionales IPBeja | Investigadores SPRINT | Docentes REDESPP",
      cat3: "Profesionales y público en general",
      registerBtn: "Inscribirme",
      lunchTitle: "Almuerzo de Celebración – 30 Años",
      lunchSubtitle: "18 de Abril 2026 • Valor adicional a la inscripción",
      priceLabel: "Valor",
      learnMore: "+ Info",
    },
    lunchModal: {
      title: "Almuerzo de Celebración – 30 Años",
      location: "Restaurante Seara",
      locationDetail: "Beja Parque Hotel. Rua Francisco Miguel Duarte, 1, Beja, 7800-510 Portugal",
      welcome: "Recepción de Bienvenida (Welcome Drink)",
      lunchTitle: "Almuerzo",
      couvert: "Couvert y Entrantes",
      couvertDesc: "Selección de pan regional, mantequilla, aceitunas, queso fresco, embutido y ensaladas variadas.",
      soup: "Sopa",
      soupDesc: "Crema de cilantro.",
      fish: "Plato de Pescado",
      fishDesc: "Bacalao gratinado con espinacas en costra de pan alentejano.",
      meat: "Plato de Carne",
      meatDesc: "Pierna de cerdo asada acompañada de patatas al horno.",
      desserts: "Postres",
      dessertsDesc: "Buffet de postres variados y fruta laminada.",
      drinks: "Bebidas incluidas durante el almuerzo",
      drinksDesc: "Agua, zumos, cerveza, vinos blanco y tinto y café.",
      liveMusic: "Música en vivo durante el almuerzo",
      note: "Nota",
      noteDesc: "Las bebidas incluidas en el servicio estarán disponibles únicamente durante el período del almuerzo. Después de este momento, cualquier consumo adicional podrá realizarse en el bar del espacio y será pagado directamente por los participantes.",
    },
    accreditation: {
      ipdjText: "IPDJ — Acreditación para revalidación del Título Profesional de Técnico de Ejercicio Físico, Entrenador Deportivo y Director Técnico (2,4 UC)",
      teacherText: "Reconocimiento de Acción de Corta Duración (6h) — Formación Continua de Profesores (Despacho nº 5741/2015, de 29 de mayo)",
    },
    masters: {
      badge: "Año Académico 2026/2027",
      title: "Máster en Actividad Física y Salud",
      subtitle: "Prepare el próximo año académico",
      studyPlan: "Plan de Estudios",
      studyPlanTitle: "Plan de Estudios",
      sem1: "1.er Año | 1.er Semestre",
      sem2: "1.er Año | 2.º Semestre",
      year2: "2.º Año | Anual",
      option: "Opción",
      thesesTitle: "Disertaciones de Máster",
      thesesSubtitle: "Investigación producida por nuestros estudiantes de máster",
      thesesCount: "disertaciones",
      author: "Autor",
      year: "Año",
      allYears: "Todos",
      testimonials: {
        t1: "Las asignaturas están muy bien organizadas y alineadas con los desafíos y contextos actuales del área de promoción de la salud y el ejercicio.",
        t2: "El máster me ayudó a desarrollar competencias para investigar de forma autónoma sobre temas relevantes e interpretar evidencia científica de forma crítica.",
        t3: "Sentí una enorme disponibilidad y apoyo de los profesores, que acompañan a los estudiantes de forma muy cercana en el desarrollo de los trabajos académicos.",
        t4: "El máster proporciona oportunidades de contacto con experiencias internacionales, a través de programas como Erasmus y programas intensivos.",
        t5: "La estructura del máster es bastante flexible, lo que facilita compaginar los estudios con la actividad profesional, siendo muy adecuado para estudiantes-trabajadores.",
        t6: "El máster me ayudó a comprender mejor las condicionantes prácticas que existen cuando evaluamos diferentes tipos de poblaciones.",
        t7: "Profundicé conocimientos en áreas con las que tenía menos contacto y adquirí competencias más técnicas para intervenciones específicas a nivel de entrenamiento individualizado.",
      },
    },
    registration: {
      subtitle: "Inscripción",
      title: "Asegure su Participación",
      description: "Seleccione su categoría y adjunte el comprobante de pago.",
      period1Title: "1er Plazo de Inscripciones",
      period1Desc: "Hasta el 22 de Marzo 2026 - ¡Precios más bajos!",
      period2Title: "2º Plazo de Inscripciones",
      period2Desc: "23 de Marzo a 12 de Abril 2026",
      closedTitle: "Inscripciones Cerradas",
      closedDesc: "El plazo de inscripciones terminó el 12 de Abril 2026",
      paymentDataTitle: "Datos de Pago",
      bank: "Banco",
      country: "País",
      holder: "Titular",
      address: "Dirección",
      formTitle: "Formulario de Inscripción",
      fullName: "Nombre Completo *",
      email: "Email *",
      institution: "Institución *",
      role: "Función *",
      selectRole: "Seleccione su función",
      roleStudentIpbeja: "Estudiante IPBeja",
      roleDiplomaIpbeja: "Diplomados IPBeja",
      roleProfessor: "Profesor/Docente",
      roleResearcher: "Investigador",
      roleProfExercise: "Profesional del Ejercicio Físico",
      roleOther: "Otro",
      participationType: "Tipo de Participación *",
      selectParticipation: "Seleccione tipo",
      participantOnly: "Participante",
      presenterComm: "Presenta comunicación (oral y/o póster)",
      tefLicense: "Nº Licencia de Técnico de Ejercicio Físico",
      optional: "Opcional",
      workshopSelection: "Selección de Talleres (opcional)",
      workshopNote: "Solo puede seleccionar un taller por horario.",
      timeSlot1: "Horario 14:30 - 16:00",
      timeSlot2: "Horario 16:30 - 18:00",
      noWorkshopSlot: "Ningún taller en este horario",
      waitingList: "Lista de Espera",
      waitingListNotice: "El WSP 6 ya ha alcanzado el número máximo de plazas. Al seleccionar este taller, quedará en lista de espera y será contactado(a) si surge una plaza.",
      registrationsClosed: "Inscripciones Cerradas",
      limitedSpots: "Plazas Limitadas",
      billing: "Datos de Facturación",
      invoiceName: "Nombre para Factura *",
      invoiceNamePlaceholder: "Nombre o entidad para la factura",
      invoiceAddress: "Dirección *",
      invoiceAddressPlaceholder: "Dirección completa de facturación",
      invoicePostalCode: "Código Postal y Localidad *",
      invoicePostalCodePlaceholder: "Ej: 7800-295 Beja",
      invoiceCountry: "País *",
      invoiceCountryPlaceholder: "Ej: Portugal",
      nif: "Número de Identificación Fiscal *",
      nifPlaceholder: "Número de contribuyente",
      lunchTitle: "Almuerzo de Celebración – 30 Años",
      lunchSubtitle: "18 de Abril 2026 • Evento especial de confraternización",
      paymentProof: "Comprobante de Pago *",
      uploadFile: "Haga clic para cargar",
      fileTypes: "PDF, JPG o PNG (máx. 10MB)",
      lunchAddon: "+ Almuerzo 30 Años",
      totalPrice: "Total a Pagar",
      closed: "Inscripciones Cerradas",
      processing: "Procesando...",
      confirmBtn: "Confirmar Inscripción",
      success: "¡Inscripción realizada con éxito!",
      successDesc: "Recibirá confirmación tras la validación del pago.",
      error: "Error en la inscripción",
      fileTooLarge: "Archivo demasiado grande",
      fileTooLargeDesc: "El archivo debe tener como máximo 10MB",
      lunchOnly: "Solo Almuerzo 30 Años",
      lunchOnlyDesc: "Inscripción exclusiva para el almuerzo de celebración",
      selectCategory: "Seleccione una categoría de inscripción",
      categoryLabel: "Categoría de Inscripción *",
      selectCategoryPlaceholder: "Elija su categoría",
      emailNotice: "Tras enviar, revise su email (incluida la carpeta de spam/correo no deseado) para la confirmación.",
      formStepNotice: "Rellene el formulario a continuación y haga clic en Confirmar para completar su inscripción.",
      xpsTitle: "Información XPS Network",
      xpsHasAccount: "¿Ya usa o ha usado XPS Network?",
      xpsYes: "Sí",
      xpsNo: "No",
      xpsEmail: "Email ya asociado a la cuenta XPS",
      xpsEmailPlaceholder: "Indique el email de su cuenta XPS",
      xpsEmailNew: "Email a asociar con la nueva cuenta XPS",
      xpsEmailNewPlaceholder: "Indique el email para crear la cuenta XPS",
    },
    sponsors: {
      subtitle: "Socios",
      title: "Organización, Colaboraciones y Apoyos",
      scrollHint: "Deslice para ver más",
      supportedBy: "Con el apoyo de",
      withSupportOf: "Con el apoyo de",
    },
    footer: {
      description: "10º Congreso Internacional de Actividad Física y Deporte.",
      contacts: "Contactos",
      links: "Enlaces",
      about: "Acerca",
      program: "Programa",
      submissions: "Envíos",
      prices: "Valores",
      registration: "Inscripción",
      admin: "Administración",
      copyright: "© 2026 CIAFD. Todos los derechos reservados.",
    },
    upload: {
      title: "Envío de Presentación",
      submissionId: "ID del Envío *",
      name: "Nombre *",
      email: "Email *",
      presentationType: "Tipo de Presentación *",
      selectType: "Seleccione tipo",
      oralComm: "Comunicación Oral",
      poster: "e-Póster",
      file: "Archivo de Presentación *",
      uploadBtn: "Haga clic para cargar archivo",
      fileTypes: "Solo archivos .ppt o .pptx",
      submitBtn: "Enviar Presentación",
      submitting: "Enviando...",
      success: "¡Presentación enviada con éxito!",
      error: "Error al enviar",
      backToSite: "Volver al sitio",
      fileSelected: "Archivo seleccionado",
    },
    admin: {
      title: "Administración",
      password: "Contraseña",
      enterPassword: "Contraseña",
      login: "Entrar",
      loggingIn: "Entrando...",
      backToSite: "Volver al sitio",
      wrongPassword: "Contraseña incorrecta",
      loginSuccess: "¡Inicio de sesión exitoso!",
      registrations: "Inscripciones",
      abstracts: "Resúmenes",
      presentations: "Presentaciones",
      stats: "Estadísticas",
      confirmed: "Confirmadas",
      revenue: "Ingresos",
      accepted: "Aceptados",
      logout: "Salir",
      refresh: "Actualizar",
      export: "Exportar Excel",
      name: "Nombre",
      email: "Email",
      type: "Tipo",
      modality: "Modalidad",
      price: "Precio",
      proof: "Comprobante",
      status: "Estado",
      actions: "Acciones",
      view: "Ver",
      pending: "Pendiente",
      confirmedStatus: "Confirmado",
      responsible: "Responsable",
      reviewer: "Revisor",
      assign: "Asignar",
      none: "Ninguno",
      revision: "Revisión",
      rejected: "Rechazado",
      noRegistrations: "Sin inscripciones",
      noSubmissions: "Sin envíos",
      noPresentations: "Sin presentaciones",
      delete: "Eliminar",
      download: "Descargar",
      resendEmail: "Reenviar email",
      statusUpdated: "Estado actualizado",
      assignmentUpdated: "Asignación actualizada",
      emailSentToReviewer: "Email enviado al revisor",
      deleted: "Eliminado",
      errorUpdating: "Error al actualizar",
      errorDeleting: "Error al eliminar",
      errorLoading: "Error al cargar datos",
      downloadWord: "Descargar Word",
      workshopStats: "Inscripciones por Taller",
      enrolled: "inscritos",
      totalRegistrations: "Total de Inscripciones",
      totalSubmissions: "Total de Envíos",
      totalRevenue: "Ingresos Totales",
      institution: "Institución",
      date: "Fecha",
      category: "Categoría",
      submissionId: "ID de Envío",
      thematicArea: "Eje Temático",
      titleLabel: "Título",
      submitter: "Autor",
      fileName: "Archivo",
      size: "Tamaño",
    },
  },
};

export const languageNames = {
  pt: "PT",
  en: "EN",
  es: "ES",
};
